import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-directional-two-view",
  templateUrl: "./directional-two-view.component.html",
  styleUrls: ["./directional-two-view.component.scss"],
})
export class DirectionalTwoViewComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() veiculoId: number;

  public sensorLeftSelect: any = [];
  public sensorRightSelect: any = [];

  public sensorRightCombo: any = [];
  public sensorLeftCombo: any = [];

  public direcionalTwoLeftForm: FormGroup;
  public direcionalTwoRightForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.direcionalTwoLeftForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: ["", Validators.required],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.direcionalTwoRightForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: ["", Validators.required],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.direcionalTwoLeftForm.controls["cdPosicaoPneu"].setValue(
        "DIRECIONAL 2 ESQ"
      );
      this.direcionalTwoRightForm.controls["cdPosicaoPneu"].setValue(
        "DIRECIONAL 2 DIR"
      );

      if (this.veiculoSensores.length > 0) {
        const direcional2Direito = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          59
        );
        const direcional2Esquerdo = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          60
        );

        //DIRECIONAL 2 DIREITO SET
        if (direcional2Direito != null) {
          this.direcionalTwoRightForm.controls["id"].setValue(
            direcional2Direito.id
          );

          if (direcional2Direito.sensor != null) {
            appendSensorToCombo(this.sensorRightCombo, direcional2Direito.sensor);
            this.sensorRightSelect = direcional2Direito.sensor.id;
          }

          if (direcional2Direito.pneu != null) {
            this.direcionalTwoRightForm.controls["pneu"].setValue(
              direcional2Direito.pneu.numeroFogo
            );
          }

          this.direcionalTwoRightForm.controls["nrPressaoMinima"].setValue(
            direcional2Direito.nrPressaoMinima
          );

          this.direcionalTwoRightForm.controls["nrPressaoMaxima"].setValue(
            direcional2Direito.nrPressaoMaxima
          );

          this.direcionalTwoRightForm.controls["nrTemperaturaMaxima"].setValue(
            direcional2Direito.nrTemperaturaMaxima
          );
        }

        //DIRECIONAL 2 ESQUERDO SET
        if (direcional2Esquerdo != null) {
          this.direcionalTwoLeftForm.controls["id"].setValue(
            direcional2Esquerdo.id
          );

          if (direcional2Esquerdo.sensor != null) {
            appendSensorToCombo(this.sensorLeftCombo, direcional2Esquerdo.sensor);
            this.sensorLeftSelect = direcional2Esquerdo.sensor.id;
          }

          if (direcional2Direito.pneu != null) {
            this.direcionalTwoLeftForm.controls["pneu"].setValue(
              direcional2Esquerdo.pneu.numeroFogo
            );
          }

          this.direcionalTwoLeftForm.controls["nrPressaoMinima"].setValue(
            direcional2Esquerdo.nrPressaoMinima
          );

          this.direcionalTwoLeftForm.controls["nrPressaoMaxima"].setValue(
            direcional2Esquerdo.nrPressaoMaxima
          );

          this.direcionalTwoLeftForm.controls["nrTemperaturaMaxima"].setValue(
            direcional2Esquerdo.nrTemperaturaMaxima
          );
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
